import { api, ApiRes } from '@src/utils/api/client'
import { Country } from '@src/types'

export interface CountriesResponse {
    countries: Country[]
}

export const getCountries = (): ApiRes<CountriesResponse> =>
    api.get('v2/countries')
